import { SET_CURRENT_PAGE, CurrentPageActionTypes } from '../actionTypes';

const setCurrentPage = (page: string): CurrentPageActionTypes => ({
  type: SET_CURRENT_PAGE,
  payload: page,
});

export default setCurrentPage;
